<script setup lang="ts">
import { computed } from 'vue'
import { rawIcon } from '@/lib/icons'

const props = withDefaults(defineProps<{ name: string; size?: number | string }>(), {
  size: 18,
})

const cls = computed(() => `ico ico-${props.size}`)
const svg = computed(() => rawIcon(props.name))
</script>

<template>
  <span :class="cls" v-html="svg" />
</template>
